import React, { Component } from "react"
import TableTermoCircunstanciadoTrash from "./TableTermoCircunstanciadoTrash"
import Layout from "../../Layout"
import { Loading, HttpError } from "../../../components"
import * as ApiHelper from "../../../ApiHelper"
import Moment from "moment"
export default class TermoCircunstanciadoTrash extends Component {
  constructor() {
    super()
    this.getTermos = this.getTermos.bind(this)
    this.didRestore = this.didRestore.bind(this)
    this.filter = this.filter.bind(this)
    this.state = { termos: [], initialTermos: [], showTable: false }
  }
  componentWillMount() {
    this.getTermos()
  }
  getTermos() {
    ApiHelper.getTermosCircunstanciadosTrash((termos, error) => {
      if (termos) {
        this.setState({
          termos: termos,
          initialTermos: termos,
          showTable: true
        })
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  filter(event) {
    var searchText = event.target.value.toLowerCase()
    var filtered = this.state.initialTermos.filter(termo => {
      return (
        Moment(termo.created_at)
          .format("D/MM/Y")
          .toLowerCase()
          .search(searchText) !== -1 ||
        termo.parecer.toLowerCase().search(searchText) !== -1 ||
        termo.ressalvaz.num_contrato.toLowerCase().search(searchText) !== -1
      )
    })
    this.setState({
      termos: filtered
    })
  }
  didRestore() {
    this.getTermos()
  }
  render() {
    if (this.state.httpError) {
      return (
        <Layout tabActive="Fiscalização">
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </Layout>
      )
    }
    return (
      <Layout tabActive="Fiscalização">
        {this.state.showTable ? (
          <TableTermoCircunstanciadoTrash
            filter={this.filter}
            onRestore={this.didRestore}
            sizeClass=""
            title={"Termos circunstanciados deletados"}
            subtitle={"Listagem dos termos circunstanciados deletados"}
            backgroundColor="as-blue"
            rows={this.state.termos}
          />
        ) : (
          <Loading />
        )}
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/fiscalizacao/termo-circunstanciado/TermoCircunstanciadoTrash.js